<template>
  <div class="hb-reject-dialog">
    <el-dialog title="驳回" :visible.sync="dialogAddUserSchoolChoice" width="60%" center destroy-on-close>
      <el-form size="small" label-width="120px"  ref="ruleFormaa" >
        <el-form-item label=""  v-if="type != 'school_choice'">
          <div slot="label"><span style="color:red">*</span>类型</div>
          <el-select
            v-model="reject_type"
            clearable
            size="mini"
            style="width: 100%"
            placeholder="请选择类型"
          >
            <el-option
              v-for="list in reject_type_list"
              :label="list.value"
              :value="list.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item prop="">
          <div slot="label"><span style="color:red">*</span>描述</div>
          <el-input type="textarea" placeholder="请输入描述" v-model="reason.content"></el-input>
        </el-form-item>
        <el-form-item >
          <div slot="label"><span v-if="needFile" style="color:red">*</span>附件</div>
          <el-upload
            :drag="true"
            :auto-upload="false"
            class="upload-demo"
            action="#"
            :on-change="function (file,fileList){ return handleChange(file,fileList) }"
            :on-remove="handleRemove"
            :file-list="fileList"
            :on-exceed="handleExceed"
            :limit="1"

          >
            <div v-if="!fileList || fileList.length == 0" class="control-wrapper" style="text-align: left">
              <el-button  size="small" >添加</el-button>
              <div class="tip-text">* 请在需要驳回的文档中添加修改批注并上传</div>
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogAddUserSchoolChoice = false">取 消</el-button>
        <el-button type="primary" @click="saveUserSchoolChoice" :loading="submitLoading">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { update_user_school_choice,user_information_document_edit } from '@/api/mycenter_studyabroad.js'
import { add_document } from "@/api/mycenter_studyabroad";
import { upload } from '@/api/public'
export default {
  name: "reject",
  props: {
    needFile:false
  },
  data() {
    return {
      reject_type: '',
      reject_type_list: [
        {
          value: '基础修改(信息校对，简单内容添加或删改)-code902'
        }, {
          value: '中级修改(文书架构调整，部分内容增加)-code903'
        }, {
          value: '高级修改-(我不理解文书行文逻辑，需要文书解析课沟通)-code904'
        }
      ],
      submitLoading:false,
      fileList: [],
      dialogAddUserSchoolChoice: false,
      reason: {
        content: '',
        url: '',
      }, // 拒绝理由
      refuseId: '',
      type: '',
      url: '',
      status: ''
    };
  },
  methods: {
    sendItem(id,type,status) {
      this.reject_type = ''
      this.dialogAddUserSchoolChoice = true
      this.refuseId = id;
      this.type = type;
      this.status = status;
      this.fileList = []
    },
    saveUserSchoolChoice () {
      if (!this.reason.content){
        this.$message.error('请输入描述')
        return
      }
      if (this.type !== 'school_choice' && !this.reject_type) {
        this.$message.error('请选择类型')
        return
      }
      const file = this.fileList[0]
      if (!file && this.needFile) {
        this.$message.error('为了老师能更好的修改，请上传批注完的附件')
        return
      }
      if (file) {
        this.filesSubmit(file.raw, file.uid)
      } else {
        this.updateStatus(this.refuseId, this.status)
      }
    },
    updateStatus(id, status) {
      user_information_document_edit({ 'reject_type': this.reject_type,'id': id, 'con': JSON.stringify(this.reason), 'status': status, 'type': this.type })
        .then(response => {
          this.submitLoading = false
          this.dialogAddUserSchoolChoice = false
          this.reason.content = ''
          this.reason.url = ''
          this.$emit('reject')
        }).catch(error=> {
          this.$message.error(error.message)
          this.submitLoading = false
        })
    },
    /**
     *
     * @param file 删除内容
     * @param fileList  剩下的内容
     */
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制上传最多1个文件`)
    },
    handleRemove(file, fileList) {
      this.fileList = fileList
    },
    handleChange(file,fileList) {
      if (this.up_type) {
        var suffix = file.raw.name.substring(file.raw.name.lastIndexOf('.') + 1)
        if (this.up_type.indexOf(suffix) === -1) {
          this.$message.error('文件上传类型不正确')
          this.fileList = []
          return false
        }
      }
      if (this.up_size) {
        if ((file.raw.size / 1024 / 1024) > this.up_size) {
          this.$message.error('文件上传大小超过限制')
          this.fileList = []
          return false
        }
      }
      this.fileList = fileList
      const files = this.fileList[0]
    },
    filesSubmit(_files,_uid) { // 文件上传
      this.submitLoading = true
      const formser = new FormData() // 获取表单的参数
      formser.append('path', 'admin_file')
      formser.append('file', _files)
      upload(formser)
        .then(response => {
          this.reason.url = response.data
          this.updateStatus(this.refuseId, this.status)
        }).catch(error => {
          this.$message.error(error.message)
          this.submitLoading = false
        })
    }
  },
};
</script>

<style lang="scss" scoped>
.hb-reject-dialog {
  .upload-demo {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    .control-wrapper {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      .tip-text {
        padding-left: 1rem;
        font-size: 12px;
        color: #909399;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/mycenter_studyabroad/component/reject.vue